import { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../translations/translations';
import '../CustomersSection.css';

const CustomersSection = () => {
  const { language } = useLanguage();
  const customers = [
    { id: 1, logo: '/customers/SSS.png', name: 'School 1' },
    { id: 2, logo: '/customers/LES.png', name: 'School 2' },
    { id: 3, logo: '/customers/bahubali.png', name: 'School 3' },
    { id: 4, logo: '/customers/bhilawdi.png', name: 'School 4' },
    { id: 5, logo: '/customers/anglo-urdu.png', name: 'School 5' },
    { id: 6, logo: '/customers/narnde.png', name: 'School 6' },
    { id: 7, logo: '/customers/gangamai.png', name: 'School 7' },
    { id: 8, logo: '/customers/acs.png', name: 'School 8' },
    { id: 9, logo: '/customers/ambpa.png', name: 'School 9' },
    { id: 10, logo: '/customers/devgad.png', name: 'School 10' },
    { id: 11, logo: '/customers/gokulshirgaon.jpg', name: 'School 11' },
    { id: 12, logo: '/customers/haripriya.png', name: 'School 12' },
    { id: 13, logo: '/customers/jamsande.png', name: 'School 13' },
    { id: 14, logo: '/customers/janata.png', name: 'School 14' },
    { id: 15, logo: '/customers/jay-shivray.png', name: 'School 15' },
    { id: 16, logo: '/customers/jaywant.jpg', name: 'School 16' },
    { id: 17, logo: '/customers/kalambi.png', name: 'School 17' },
    { id: 18, logo: '/customers/kaneri.png', name: 'School 18' },
    { id: 19, logo: '/customers/mtes.png', name: 'School 19' },
    { id: 20, logo: '/customers/nhs.png', name: 'School 20' },
    { id: 21, logo: '/customers/padel.png', name: 'School 21' },
    { id: 22, logo: '/customers/phonda.png', name: 'School 22' },
    { id: 23, logo: '/customers/pvdpssp.png', name: 'School 23' },
    { id: 24, logo: '/customers/shirgaon.png', name: 'School 24' },
    { id: 25, logo: '/customers/talebajar.png', name: 'School 25' },
    { id: 26, logo: '/customers/turchi.png', name: 'School 26' },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [logosPerView, setLogosPerView] = useState(5);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setLogosPerView(5);
      } else if (window.innerWidth >= 768) {
        setLogosPerView(4);
      } else {
        setLogosPerView(2);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-scroll carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % customers.length);
    }, 5000); // Move every 5 seconds to match animation duration

    return () => clearInterval(interval);
  }, [customers.length]);

  const getVisibleLogos = () => {
    const visible = [];
    for (let i = 0; i < logosPerView; i++) {
      visible.push(customers[(currentIndex + i) % customers.length]);
    }
    return visible;
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + customers.length) % customers.length);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % customers.length);
  };

  return (
    <section className="customers-section" id="customers">
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>{getTranslation(language, 'customersSection.title')}</h2>
          <p>
            {getTranslation(language, 'customersSection.subtitle')}
          </p>
        </div>

        <div className="customers-carousel-container" data-aos="fade-up">
          <button 
            className="carousel-button prev-button" 
            onClick={handlePrev}
            aria-label={getTranslation(language, 'customersSection.previousCustomers')}
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          <div className="carousel-wrapper">
            <div className="carousel-inner">
              {getVisibleLogos().map((customer, index) => (
                <div 
                  key={customer.id} 
                  className={`carousel-item-customer ${index === 0 ? 'active' : ''}`}
                >
                  <div className="customer-logo-container">
                    <img 
                      src={customer.logo} 
                      alt={customer.name}
                      className="customer-logo"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button 
            className="carousel-button next-button" 
            onClick={handleNext}
            aria-label={getTranslation(language, 'customersSection.nextCustomers')}
          >
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CustomersSection;
